import { Backdrop, Box, BoxProps, CircularProgress, styled } from "@mui/material";

export type CircularLoaderProps = {
  size?: number;
  thickness?: number;
};

const CircularLoader: React.FC<CircularLoaderProps> = ({ size = 100, thickness = 4 }) => {
  return (
    <Backdrop open={true}>
      <StyledLoaderWrapper>
        <CircularProgress size={size} thickness={thickness} disableShrink />
      </StyledLoaderWrapper>
    </Backdrop>
  );
};

const StyledLoaderWrapper = styled(Box)().withComponent((props: BoxProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }} {...props} />
));

export default CircularLoader;
